<template>
  <VanPopup
    :show="show"
    @update:show="emit('update:show', $event)"
    class="w-[80%] max-h-[90%] max-w-[440px] rounded"
  >
    <ul class="flex flex-col p-4 gap-4">
      <li
        v-for="item in userStore.isCNUser ? list : list.slice(0, -1)"
        @click="item.action"
        class="w-full grid grid-cols-[auto_1fr] gap-x-4 gap-y-1.5 items-center border p-[18px] text-xs rounded-lg"
      >
        <div class="row-span-2 text-left text-primary">
          <i :class="['iconfont  text-[30px] ', item.icon]" />
        </div>

        <h3 class="font-bold text-sm">{{ item.title }}</h3>
        <p>{{ item.content }}</p>
      </li>
    </ul>

    <div class="text-center mb-4">
      <button class="btn btn-sm" @click="emit('update:show', false)">
        {{ t("Buttons.close") }}
      </button>
    </div>
  </VanPopup>
</template>
<script lang="ts" setup>
import { useGlobalUser } from "@/stores/globalUser";
import { useI18n } from "vue-i18n";
import { useRouter, useRoute } from "vue-router";

const { t } = useI18n();

const router = useRouter();
const route = useRoute();
const userStore = useGlobalUser();
const props = defineProps({
  show: {
    type: Boolean,
    required: true,
  },
});

const list = [
  {
    title: t("painting.traitType.preset.title"),
    content: t("painting.traitType.preset.content"),
    icon: "icon-character1",
    action: () => toCreateTraitTask(7),
  },
  {
    title: t("painting.traitType.text.title"),
    content: t("painting.traitType.text.content"),
    icon: "icon-Aa",
    action: () => toCreateTraitTask(8),
  },
  {
    title: t("painting.traitType.img.title"),
    content: t("painting.traitType.img.content"),
    icon: "icon-image",
    action: () => toCreateTraitTask(9),
  },
  {
    title: t("painting.traitType.mix.title"),
    content: t("painting.traitType.mix.content"),
    icon: "icon-update",
    action: () => toCreateTraitTask(1),
  },
];

const toCreateTraitTask = (mode: number) => {
  let query: any = { mode };
  if (route.params.uuid) query.uuid = route.params.uuid;
  router.push({ name: "createTraitTask", query });
  emit("update:show", false);
};

const emit = defineEmits({
  "update:show": (val: boolean) => undefined,
  generate: () => undefined,
});

const clickBuyMore = () => {
  router.push(`/crystal`);
};
</script>
